import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {IUser, IUsers} from "@/entity/user/user.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {prepareFormData} from "@/store/utils/formDataHelper";

@Module({
    namespaced: true,
    name: 'user',
    store,
    dynamic: true,
})
class UserModule extends VuexModule {
    users: IUsers = { total : 0, data: [] };
    user: IUser | null = null;
    itemLoading = false;
    itemsLoaded = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ users: IUsers; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const users = await store.$repository.user.fetchAll(prepareFormData(data));
        if (users) {
            itemsLoaded = true;
        }
        return { users, itemsLoaded };
    }

    @MutationAction
    async fetch(): Promise<{ user: IUser; itemLoading: boolean }> {
        const user = await store.$repository.user.fetch();
        let itemLoading = false;
        if (user) {
            itemLoading = true;
        }
        return {user, itemLoading};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.user.delete({id: id});
    }
}

export const UserStore = getModule(UserModule);
